import $ from 'jquery';

export default class FareConditionAdvice {

    public initializePopup(delegateSelector: string, closeButtonSelector: string): void {
        $('.booking-form').magnificPopup({
            delegate: delegateSelector,
            type: 'inline',
            fixedContentPos: true,
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: true,
            mainClass: 'mfp-fade',
            callbacks: {
                ajaxContentAdded: () => {
                    $(closeButtonSelector).on('click', event => $.magnificPopup.close());
                },
                afterClose: () => {
                    // Remove click event handler from close button
                    $(closeButtonSelector).off('click');
                },
            },
        });
    }
}
